import { connect } from 'react-redux'
import * as action from '../../state/instance-detail/action'
import * as selector from '../../state/instance-detail/selector'
import { selectHasRole } from '../../../security/state/auth/selector'
import { ROLE_PRODUCTION_ADMIN } from '../../../security/state/auth/const'

import InstanceDetail from './InstanceDetail'

const mapStateToProps = (state, props) => {
    return {
        processInstanceId: props.computedMatch.params.processInstanceId,
        masterId: props.computedMatch.params.masterId,
        masterObject: props.computedMatch.params.masterObject,
        processInstance: selector.selectProcessInstance(state),
        fetching: selector.selectIsFetching(state),
        processFlowVisible: selector.selectProcessFlowVisible(state),
        availableTransitionList: selector.selectAvailableTransitionList(state),
        processLogList: selector.selectProcessLogList(state),
        commentText: selector.selectCommentText(state),
        commentList: selector.selectCommentList(state),
        taskName: selector.selectCurrentTaskName(state),
        context: selector.selectProcessContext(state),
        availableStateList: selector.selectAvailableStateList(state),
        beamProcessState: selector.selectBeamProcessState(state),
        validationMessageList: selector.selectValidationMessageList(state),
        openTask: selector.selectOpenTask(state),
        isProductionAdmin: selectHasRole(state, ROLE_PRODUCTION_ADMIN),
    }
}

const mapDispatchToProps = {
    findProcessInstance: action.findProcessInstance,
    findProcessInstanceByMasterId: action.findProcessInstanceByMasterId,
    toggleProcessFlowVisibility: action.toggleProcessFlowVisibility,
    toggleVIPStatus: action.toggleVIPStatus,
    toggleRushStatus: action.toggleRushStatus,
    changeProcessComment: action.changeProcessComment,
    commentProcessInstance: action.commentProcessInstance,
    changeProcessContext: action.changeProcessContext,
    saveProcessContext: action.saveProcessContext,
    changeBeamProcessState: action.changeBeamProcessState,
    beamProcessInstance: action.beamProcessInstance,
    changeTime: action.changeTime,
    validateAndTriggerEvent: action.validateAndTriggerEvent,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InstanceDetail)



// WEBPACK FOOTER //
// ./src/modules/process/component/instance-detail/InstanceDetailContainer.js